// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1p0Mc","modalForm":"UpgradeEpcsModal_modalForm__1QZpf","modalFooter":"UpgradeEpcsModal_modalFooter__2zk_C"};